import { render, staticRenderFns } from "./elCardShow2.vue?vue&type=template&id=befcd418&scoped=true"
import script from "./elCardShow2.vue?vue&type=script&lang=js"
export * from "./elCardShow2.vue?vue&type=script&lang=js"
import style0 from "./elCardShow2.vue?vue&type=style&index=0&id=befcd418&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "befcd418",
  null
  
)

export default component.exports